import './horizontalEffect.scss';
import './verticalEffect.scss';

import horizontalEffectTpl from './effect.ejs';
import horizontalEffectContentBoxTpl from './effect-content-box.ejs';
import horizontalEffectComboBoxTpl from './effect-combo-box.ejs';

import { Transform, RAF } from 'f.component.util';

class horizontalEffect {
    constructor(presentInfo) {
        this.presentInfo = presentInfo;
        this.width = document.documentElement.clientWidth;
        this.height = document.documentElement.clientHeight;

        this.containerDom = null; // 总容器
        this.contentBoxDom = null; // 内容容器
        this.comboBoxDom = null; // combo容器
        this.contentBox = null; // 内容
        this.comboBox = null; // combo

        this.init();
    }

    init() {
        this.initDom();
        Transform(this.containerDom[0]);
        Transform(this.comboBoxDom[0]);
    }

    renderhorizontalEffect() {
        return horizontalEffectTpl();
    }

    renderContentBox(data) {
        return horizontalEffectContentBoxTpl(data);
    }

    renderComboBox(data) {
        return horizontalEffectComboBoxTpl(data);
    }

    initDom(data) {
        this.containerDom = $(this.renderhorizontalEffect());
        this.contentBoxDom = this.containerDom.find('.content-box');
        this.comboBoxDom = this.containerDom.find('.combo-box');
        $('body').append(this.containerDom);
    }

    emptyDom() {
        this.contentBoxDom.empty();
        this.comboBoxDom.empty();
    }

    tween(...args) {
        return new animate(...args);
    }

    getCombo(data) {
        if (!data || !data.combo) {
            return [1];
        }

        let _combo = (data.combo + '').split('');
        console.log('combo-----', _combo)
        return _combo;
    }

    getContent(data) {
        return {
            avatar: data.avatar,
            nickname: data.nickname,
            presentName: this.getPresentInfo(data.id).name || '',
            presentImg: this.getPresentInfo(data.id).pic || ''
        }
    }

    getPresentInfo(id) {
        let _d = this.presentInfo.filter((present) => {
            return present.id == id;
        })

        return _d[0] || {};
    }

    // 初始化内容
    start({ newData, oldData }) {
        var _this = this;
        return new Promise((resolve, reject) => {
            // console.log(_this.getContent(newData))
            _this.contentBox = _this.renderContentBox(_this.getContent(newData));
            _this.contentBoxDom.html(_this.contentBox);

            let _d = null;
            if (oldData && oldData.combo) {
                _d = oldData.combo + 1
            }
            // _this.comboBox = _this.renderComboBox({data : _this.getCombo({combo: _d || 1})});
            // _this.comboBoxDom.html(_this.comboBox);

            _this.containerDom[0].translateX = -1 * _this.width;
            _this.containerDom[0].translateY = 0;

            resolve({ newData, oldData });
        })
    }

    // 开始进入可视区
    enter({ newData, oldData }) {
        var _this = this;
        return new Promise((resolve, reject) => {
            _this.containerDom
                .show()
                .css('opacity', 1)
                .animate({ translateX: 0 }, 1000, () => {
                    // console.log(newData, oldData)
                    resolve({ newData, oldData });
                })
        })
    }

    process({ newData, oldData }) {
        var _this = this;
        return new Promise((resolve, reject) => {
            // console.log(newData, oldData)
            let _s = 0;
            let _d = parseInt(newData.combo);

            oldData && oldData.combo && (_s = parseInt(oldData.combo));

            return _this.runCombo(_s, _d).then(() => resolve({ newData, oldData }));
        })
    }

    runCombo(start, end) {
        // console.log(start,end)
        var _this = this;
        return new Promise((resolve, reject) => {

            if (start == end) {
                resolve(true);
            } else {
                console.log(start, end)
                let _fun = () => {
                    if (start == end) {
                        resolve(true);
                    } else {

                        return _this.runCombo(start + 1, end).then(resolve)
                    }
                }

                _this.comboBox = _this.renderComboBox({ data: _this.getCombo({ combo: start + 1 }) });
                _this.comboBoxDom.html(_this.comboBox);

                _this.comboBoxDom[0].scaleX = _this.comboBoxDom[0].scaleY = _this.comboBoxDom[0].scaleZ = 1.5;
                _this.comboBoxDom
                    .css('opacity', 1)
                    .animate({
                        scaleX: 1,
                        scaleY: 1,
                        scaleZ: 1
                    }, 200, 'linear', _fun);
            }
        })
    }

    leave({ newData, oldData }) {
        var _this = this;
        return new Promise((resolve, reject) => {
            _this.containerDom
                .animate({ translateY: -100, 'opacity': 0 }, 500, function() {
                    resolve({ newData, oldData });
                });
        })
    }

    end({ newData, oldData }) {
        var _this = this;
        return new Promise((resolve, reject) => {
            _this.emptyDom();
            _this.comboBoxDom.css('opacity', 0);
            _this.containerDom.hide();
            resolve({ newData, oldData });
        })
    }

    setVerticalEffectTop(top) {
        let cssRule = `
            .vertical .effect-box.verticalTop{
                top: ${top}
            }
        `

        this.insertCSS(cssRule);
        this.containerDom.addClass('verticalTop');
    }

    insertCSS(rule) {
        var style = document.createElement("style");
        style.innerHTML = rule;
        document.head.appendChild(style);
        
        return;
    }
}

export default horizontalEffect;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.gift.mobile/app/lib/effect/effect.js